document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector("#header-component");
    if (!header) return;
    let ticking = false;
    function updateMenuStyle() {
        const target = window.innerWidth <= 1100 ? "drawer" : "menu";
        const current = header.getAttribute("data-menu-style");
        if (current !== target) {
            header.setAttribute("data-menu-style", target);
        }
        ticking = false;
    }
    updateMenuStyle();
    window.addEventListener("resize", updateMenuStyle, { passive: true });
    const observer = new MutationObserver(() => {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(updateMenuStyle);
        }
    });
    observer.observe(header, {
        attributes: true,
        attributeFilter: ["data-menu-style"]
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll('.tab-btn-faq');
    const panels = document.querySelectorAll('.tab-panel-faq');

    buttons.forEach((btn, index) => {

        if (index === 0) {
            btn.classList.add('active');
            panels.forEach(p => {
                p.classList.add('show');
                setTimeout(() => p.classList.add('animate'), 10);
            });
        }

        btn.addEventListener('click', () => {

            buttons.forEach(b => b.classList.remove('active'));
            btn.classList.add('active');

            // 1. Get the target topic class by filtering out 'tab-btn-faq' and 'active'
            const filterClass = Array.from(btn.classList).find(cls => cls !== 'tab-btn-faq' && cls !== 'active');
            console.log('Target Filter Class:', filterClass);

            panels.forEach(panel => {
                panel.classList.remove('animate');

                setTimeout(() => {
                    // 2. Use the specific class or look for 'All' in the button text/classes
                    if (btn.textContent.includes('All') || btn.classList.contains('All') || (filterClass && panel.classList.contains(filterClass))) {
                        panel.classList.add('show');
                        setTimeout(() => panel.classList.add('animate'), 10);
                        console.log('Included:', panel.className);
                    } else {
                        panel.classList.remove('show');
                        console.log('Not Included:', panel.className);
                    }

                }, 200);
            });
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    function faqsAccordion() {
        var accordionSections = document.querySelectorAll(".accordion-item");

        if (accordionSections.length > 0) {
            var firstAccordionItemHeader = accordionSections[0].querySelector(
                ".accordion-item-header"
            );
            var firstAccordionItemBody =
                firstAccordionItemHeader.nextElementSibling;

            if (firstAccordionItemBody) {
                firstAccordionItemHeader.classList.add("active");
                firstAccordionItemBody.style.maxHeight =
                    firstAccordionItemBody.scrollHeight + "px";
            }

            for (let i = 1; i < accordionSections.length; i++) {
                var otherHeader = accordionSections[i].querySelector(
                    ".accordion-item-header"
                );
                var otherBody = otherHeader.nextElementSibling;

                if (otherBody) {
                    otherHeader.classList.remove("active");
                    otherBody.style.maxHeight = "0";
                }
            }
        }

        accordionSections.forEach((section) => {
            var accordionItemHeaders = section.querySelector(
                ".accordion-item-header"
            );
            var accordionItemBody = section.querySelector(".accordion-item-body");

            accordionItemHeaders.addEventListener("click", function () {
                var currentlyActiveHeader = document.querySelector(
                    ".accordion-item-header.active"
                );
                var currentlyActiveBody = currentlyActiveHeader
                    ? currentlyActiveHeader.nextElementSibling
                    : null;

                if (currentlyActiveHeader && currentlyActiveBody) {
                    currentlyActiveHeader.classList.remove("active");
                    currentlyActiveBody.style.maxHeight = 0;
                }

                if (accordionItemHeaders !== currentlyActiveHeader) {
                    accordionItemHeaders.classList.add("active");
                    accordionItemBody.style.maxHeight =
                        accordionItemBody.scrollHeight + "px";
                } else {
                    accordionItemHeaders.classList.remove("active");
                    accordionItemBody.style.maxHeight = 0;
                }
            });
        });
    }

    faqsAccordion();
});

document.addEventListener('DOMContentLoaded', function () {
    const videoBoxes = document.querySelectorAll('.why-choose-video-box');
    let currentlyPlaying = null;
    videoBoxes.forEach((box) => {
        const video = box.querySelector('video');
        const playBtn = box.querySelector('.video-playBtn');
        playBtn.addEventListener('click', function () {
            if (currentlyPlaying === video) {
                video.pause();
                box.classList.remove('active');
                playBtn.classList.remove('active');
                currentlyPlaying = null;
                return;
            }
            if (currentlyPlaying) {
                currentlyPlaying.pause();
                currentlyPlaying.closest('.why-choose-video-box').classList.remove('active');
                currentlyPlaying
                    .closest('.why-choose-video-box')
                    .querySelector('.video-playBtn')
                    .classList.remove('active');
            }
            video.play();
            box.classList.add('active');
            playBtn.classList.add('active');
            currentlyPlaying = video;
        });
        video.addEventListener('pause', function () {
            if (currentlyPlaying === video) {
                box.classList.remove('active');
                playBtn.classList.remove('active');
                currentlyPlaying = null;
            }
        });
        video.addEventListener('ended', function () {
            box.classList.remove('active');
            playBtn.classList.remove('active');
            currentlyPlaying = null;
        });
    });
});